import React, {Component} from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import LatestRepliesFeedContainer from './LatestRepliesFeedContainer';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import {fetchLatesRepliesLatestFeed, checkSubject} from '../actions';
import { Icon } from 'antd';

const container = connect(
  createSelector(
    (state) => ({
      panel_row3_left: _.get(state, 'subject.panel_row3_left'),
      subjects: _.get(state, 'subject.entities'),
      checkSubjectId: _.get(state, 'home.subjectId'),
    }),
    (state) => {
      const {panel_row3_left, checkSubjectId, subjects} = state;
      return {
        panel_row3_left, subjects, checkSubjectId
      }
    }
  )
)

class LatestRepliesLayout extends Component {

  diapatchFeed = (action) => {
    const {dispatch} = this.props;
    dispatch(fetchLatesRepliesLatestFeed(action));
  }

  componentDidMount() {
    const {dispatch, panel_row3_left} = this.props;
    dispatch(checkSubject(_.get(panel_row3_left, 'data[0]')));
  }

  dispatchSubject = (data) => {
    const {dispatch} = this.props;
    dispatch(checkSubject(data));
  }

  render() {
    const {dispatch, panel_row3_left, subjects, checkSubjectId} = this.props;
    return (
      <div>
        <div>
          {_.map(_.get(panel_row3_left, 'data'), (subjectId, i) => {
            const subject = subjects[subjectId];
            const length = _.get(panel_row3_left, 'data.length')
            return (
              <div className={classnames('panel-item', {
                "panel-item-active": checkSubjectId == subjectId,
                "first-blue": i == 0,
                "second-blue": i == 1,
                "third-blue": i == 2,
                "fourth-blue": i == 3,
                "fifth-blue": i == 4,
              })} onClick={() => this.dispatchSubject(subjectId)}>
                <Icon style={{ verticalAlign: 'middle'}} type="pushpin-o" />
                <span className="margin-left-md">{_.get(subject, 'name')}</span></div>
            )
          })
          }
        </div>
        <div style={{background: '#fff',paddingTop: "10px", minHeight: '380px', marginRight: '10px',width:'494px'}}>
          <LatestRepliesFeedContainer dispatch={this.diapatchFeed} originDispatch={dispatch}/>
        </div>
      </div>
    )
  }
}

export default container(LatestRepliesLayout)



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/LatestRepliesLayout.js
 **/